import React, {useState} from "react"
import { Btn, FormTextarea, Modal } from "./";
import {useCore} from "../hooks";

export const ModalNotes: React.FC = () => {
  const { currentOrder, setCurrentOrder } = useCore()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [note, setNote] = useState<string>('')
  const [privateNote, setPrivateNote] = useState<string>('')

  const openModal = () => {
    setNote(currentOrder?.note || '')
    setPrivateNote(currentOrder?.privateNote || '')
    setIsVisible(true)
  }

  const closeModal = () => {
    setNote('')
    setPrivateNote('')
    setIsVisible(false)
  }

  const updateOrderNotes = () => {
    const nextOrder = {...currentOrder}
    nextOrder.note = note
    nextOrder.privateNote = privateNote
    setCurrentOrder(nextOrder)
    closeModal()
  }

  return (
    <Modal
      modalOpenBtn={<Btn className="btn-link font-bold" children={'Poznámka'} onClick={openModal} />}
      isVisible={isVisible}
      modalTitle={'Poznámka'}
      modalWidth={'sm'}
      onClose={closeModal}
      content={
        <div>
          <FormTextarea label={'Poznámka'} value={note} onChange={e => setNote(e)} />
          <FormTextarea label={'Skrytá poznámka'} value={privateNote} onChange={e => setPrivateNote(e)} />
        </div>
      }
      footerContent={
        <div className="flex flex-row justify-between items-center">
          <Btn className="btn-base-100" icon={'fa-times'} children={'Zrušit'} onClick={() => setIsVisible(false)}/>
          <Btn className="btn-primary" icon={'fa-check'} children={'Upravit poznámku'} onClick={updateOrderNotes}/>
        </div>
      }
    />
  )
}
